import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'
import { FillClose } from 'components/lib/DesignSystem/Icons'
import Input from 'components/lib/DesignSystem/Input'

class SlackThirdStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  handleEditUrl = (e) => this.props.updateWebhookUrl(e.target.value)

  handleCompleteIntegration = () => this.props.updateNotifications()

  render() {
    const { className, webhookUrl, error, permissions, isStaticSalesDemo } = this.props

    return (
      <div className={className}>
        <img
          src={`${STATIC_BASE_URL}/static/webapp/images/settings/slack-third-screenshot.png`}
          className="screenshot"
        />
        <div className="actions-container">
          <div className="number-indication">1</div>
          <span className="text-indication">Copy WebHook URL, and paste it below</span>
          <div className="url-container">
            <Input
              id="Settings_NotificationsSlack_ThirdStep_URL_input"
              labelText="WebHook URL"
              placeholder="Paste URL"
              value={webhookUrl}
              onChange={this.handleEditUrl}
              style={{ width: '290px' }}
              meta={{
                error: error?.detail,
                touched: Boolean(error),
                icon: <FillClose />,
              }}
            />
          </div>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="slack-backButton"
          />
          <Button
            text="Complete Integration"
            disabled={
              !webhookUrl ||
              !webhookUrl.includes('hooks.slack.com') ||
              !permissions.admin ||
              isStaticSalesDemo
            }
            onClick={this.handleCompleteIntegration}
            className="sml"
            id="slack-completeIntegrationButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(SlackThirdStep)`
  .url-container {
    margin-top: 25px;
  }
  .buttons-container {
    margin-top: ${(props) => (props.error ? '40px' : '74px')};
  }
`
